module.exports = __webpack_public_path__ + "img/btn_HIGH_lose.6293e0e8.png";